import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { changePassword, getCurrentUser } from '../services/api';
import { useI18n } from '../i18n/I18nContext';
import styles from './ChangePassword.module.css';

function ChangePassword() {
  const { t } = useI18n();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [isResetRequired, setIsResetRequired] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // 檢查是否需要輸入當前密碼
    getCurrentUser()
      .then(response => {
        setIsResetRequired(response.data.password_reset_required);
      })
      .catch(err => {
        console.error('取得用戶資訊失敗:', err);
      });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    // 驗證新密碼
    if (newPassword.length < 8) {
      setError(t('changePassword.error_min_length'));
      return;
    }

    if (newPassword !== confirmPassword) {
      setError(t('changePassword.error_mismatch'));
      return;
    }

    setLoading(true);

    try {
      await changePassword(
        isResetRequired ? undefined : currentPassword,
        newPassword
      );
      navigate('/chat');
    } catch (err) {
      const errorMessage = err.response?.data?.error || t('changePassword.default_error');
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.changePasswordContainer}>
      <div className={styles.changePasswordBox}>
        <h1>{t('changePassword.title')}</h1>
        
        {isResetRequired && (
          <div className={styles.infoMessage}>
            {t('changePassword.info_first_login')}
          </div>
        )}

        {error && <div className={styles.errorMessage}>{error}</div>}

        <form onSubmit={handleSubmit}>
          {!isResetRequired && (
            <div className={styles.formGroup}>
              <label htmlFor="current-password">{t('changePassword.label_current')}</label>
              <input
                type="password"
                id="current-password"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                required
                disabled={loading}
              />
            </div>
          )}

          <div className={styles.formGroup}>
            <label htmlFor="new-password">{t('changePassword.label_new')}</label>
            <input
              type="password"
              id="new-password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              disabled={loading}
              minLength={8}
            />
            <small>{t('changePassword.hint_min_length')}</small>
          </div>

          <div className={styles.formGroup}>
            <label htmlFor="confirm-password">{t('changePassword.label_confirm')}</label>
            <input
              type="password"
              id="confirm-password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              disabled={loading}
              minLength={8}
            />
          </div>

          <button
            type="submit"
            className={styles.submitButton}
            disabled={loading}
          >
            {loading ? t('changePassword.submit_loading') : t('changePassword.submit')}
          </button>
        </form>
      </div>
    </div>
  );
}

export default ChangePassword;
